// adminportal/src/main.tsx
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { loadConfig, setGlobalConfig } from './config';

async function bootstrap() {
  try {
    const cfg = await loadConfig();
    setGlobalConfig(cfg);
  } catch (err) {
    console.error('Failed to load /config.json runtime config:', err);
    // still render the app so you see an error UI instead of a blank page
  }

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element #root not found');

  createRoot(rootEl).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
}

bootstrap();
